import { STATUS_LABELS, STATUS_COLORS } from "@/lib/api";

export function StatusPill({ status }) {
  const color = STATUS_COLORS[status] || "#0A0A0A";
  return (
    <span
      className="status-pill"
      style={{ borderColor: color, color }}
      data-testid={`status-pill-${status}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: color }}
      />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function OverdueBadge() {
  return (
    <span className="overdue-badge" data-testid="overdue-badge">
      <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      >
        <path d="M12 9v4M12 17h.01" />
        <circle cx="12" cy="12" r="10" />
      </svg>
      Tiempo excedido
    </span>
  );
}
